package org.dronda.app.web.ui.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import org.dronda.app.web.Loader

@Composable
fun LoginScreen(
    loginViewModel: LoginViewModel,
) {
    LaunchedEffect(Unit) {
        loginViewModel.take(LoginViewModel.Event.BeginLoginFlow)
    }
    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Loader()
    }
}